import React from 'react'

function Services({notification, changeOption}) {
  const {receive_orders} = notification || '';

  return (
    <div className="services">
        <label htmlFor="messages-options" className="title-label">Obsługa klientów serwisu</label>
        <div className="option">
            <input type="checkbox" id="receive_orders" name="receive_orders" value="receive_orders" checked={receive_orders} onClick={() => changeOption('receive_orders')}/>
            <label htmlFor="receive_orders">Chcę by klienci serwisu mogli zamawiać u mnie wizytę lub usługę</label>
        </div>
        <div className="service-description">
            <p><strong style={{fontWeight:"600"}}>Ustaw</strong> tę opcję, jeśli klienci naszego serwisu mają mieć możliwość kontaktowania się z Twoją kancelarią.</p>
            <ol>
                <li>Aktywne stają się przyciski „ZAMÓW WIZYTĘ”, „ZAMÓW USŁUGE”, „WYBIERAM” i gdy klient je naciska, do prawnika wysyłane jest powiadomienie SMS-em i mailem.</li>
                <li>Serwis oczekuje do 4 godzin na potwierdzenie przez prawnika (SMS-em lub mailem) chęci obsługi tego klienta. Po tym czasie klientowi jest proponowany inny prawnik.</li>
                <li>Po otrzymaniu potwierdzenia serwis przekazuje prawnikowi dane kontaktowe do klienta (telefonem, mailem).</li>
            </ol>
            <p><strong style={{fontWeight:"600"}}>Wyłącz</strong> tę opcję, jeśli Twoje oferty maja być tylko biernie wyświetlane.</p>
        </div>
    </div>
  )
}

export default Services